// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2PDM2","container":"styles_container__2MBA-","title":"styles_title__1PqN8","wrapper":"styles_wrapper__1M2JZ","answer":"styles_answer__2SvR3"};